<template>
  <div class="adjusted-values single-step">
    <div class="heading">
      <div>
        <h2 id="vvv">{{$ml.get(`Adjusted values`)}}</h2>
        <info-tip :title="$ml.get(`Here you can see your crop needs considering your field conditions`)"/>
      </div>
      <app-btn @click="recalculate" :disabled="$store.getters['program/isFinished']">
        {{$ml.get(`RECALCULATE`)}}
      </app-btn>
    </div>
    <p>{{$ml.get(`This information is based on your previous steps and field hectares`)}}</p>
    <Table :recFlag="recFlag" />
    <!-- <div class="button-container">
      <app-btn styling="inline" @click="$store.dispatch('program/goToPrevStep');" class="margin-around">{{ $ml.get(`Previous`) }}</app-btn>
      <app-btn @click="test" class="margin-around">{{ $ml.get(`Previous`) }}</app-btn>
      <app-btn
        @click="$store.dispatch('program/goToNextStep')"
        class="next"
      >{{ $ml.get(`next`) }}</app-btn>
    </div> -->
  </div>
</template>

<script>
import API from '@/api';
import Table from './Table';

export default {
  data () {
    return {
      recFlag: 0
    }
  },
  components: {
    Table,
  },
  destroyed() {
    this.$store.dispatch('program/canGoToNextStep', true);
  },
  methods: {
    async getPdf () {
      var result = await API.pdf.getPdfForAdjust(this.$route.params.programId);
      // var result = await API.pdf.getGlobalPdf(this.$route.params.programId);
      var blob = new Blob([result.data], {type: 'application/pdf'});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'adjust.pdf';
      link.click();
    },
    recalculate () {
      this.recFlag++;
    }
  }
}
</script>

<style lang="scss" scoped>

.adjusted-values {
  // padding-top: 50px;
  // padding: 50px 48px 0;
  .button-container {
    display: flex;
    justify-content: flex-end;
    padding-top: 32px;
  }
  .heading {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    & > div:first-child {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .title {
      // font-size: 22px;
      // color: #4C5056;
      // margin-bottom: 35px;
    }

    .text {
      font-size: 14px;
    }
  }
}

</style>
